import {Cureus} from '../Cureus';

Cureus.AdminAffiliations = {}
//= require_tree ./AdminAffiliations